// 考点维护
<template>
  <div>
    <c-table-search
      :queryParams="queryParams"
      @doSearch="loadData"
      :immedQuery="false"
      ref="searchPanel"
    >
    </c-table-search>

    <CActionPanel
      :actions="actions"
      @importPoint="importPoint"
    ></CActionPanel>

    <div class="block">
      <c-table
        @handlePageChange="handlePageChange"
        :dataSource="dataSource"
        :pagination="pagination"
      >
        <template>
          <el-table-column
            prop="name"
            label="考点名称"
          >
          </el-table-column>

          <el-table-column
            prop="code"
            label="考点编号"
          >
          </el-table-column>

          <el-table-column
            prop="placeCount"
            label="考场数量"
          >
          </el-table-column>

          <el-table-column
            prop="examineeCount"
            label="考生人数"
          >
          </el-table-column>

          <el-table-column
            prop="code"
            label="操作"
          >
            <template slot-scope="{row}">
              <div class="actions">
                <a @click="editPost(row)">考点编辑</a>
                <el-divider direction="vertical"></el-divider>
                <a @click="editRoom(row)">考场编辑</a>
                <el-divider direction="vertical"></el-divider>
                <a @click="handleDelete(row)">删除</a>
              </div>

            </template>
          </el-table-column>
        </template>

        <template v-slot:download>
          <a
            href="javascript:;"
            @click="downLoadTemplate"
          >考点模板下载</a>
        </template>

      </c-table>
    </div>
    <c-model
      ref="pointModel"
      title="考点编辑"
      @confirm="savePoint"
    >
      <el-form
        ref="pointForm"
        :model="point"
        label-width="100px"
        :disabled="disabled"
      >
        <el-form-item
          label="考点编号:"
          prop="code"
          required
        >
          <el-input v-model="point.code"></el-input>
        </el-form-item>

        <el-form-item
          label="考点名称:"
          prop="name"
          required
        >
          <el-input v-model="point.name"></el-input>
        </el-form-item>
      </el-form>

    </c-model>
    <c-room-model
      ref="roomModel"
      :data="this.roomList"
      :examId='examId'
      :disabled="disabled"
      @saveRoom="saveRoom"
    ></c-room-model>

    <c-import-model
      @finished="confirmImportPoint"
      title="导入考点信息"
      ref="importModel"
    ></c-import-model>
  </div>

</template>

<script>
import { postRes, roomRes } from '@/api'
import { PAGE_SIZE } from '@/config/GlobalText'
import TableMixin from '@/mixins/TableMixin'
import UeditorMixin from '@/mixins/UeditorMixin'
import { mapGetters } from 'vuex'
import CRoomModel from './components/C-Room-Model'
export default {
  mixins: [TableMixin, UeditorMixin],
  components: { CRoomModel },
  data: function() {
    return {
      queryParams: [
        {
          label: '招考信息',
          type: 'select',
          code: 'examId',
          options: []
        }
      ],
      point: {},
      roomList: [],
      examId: '',
      activeRow: {},
      //考点是否可以编辑(根据招考信息是否生成了准考证判断)
      disabled: false,
      actions: [
        {
          name: '导入考点信息',
          emitCallback: 'importPoint'
        }
      ]
    }
  },
  mounted() {
    this.loadListForQuery()
  },
  computed: {},
  methods: {
    list(params) {
      this.examId = params.examId
      var data = { ...params, pageSize: this.PAGE_SIZE }
      postRes.getPage(data).then(res => {
        var { total, records } = res
        this.pagination.total = total
        this.dataSource = records
      })
    },
    editPost(row) {
      this.point = Object.assign({}, row)
      this.openModel('pointModel')
    },
    savePoint() {
      postRes.savePoint(this.point).then(res => {
        this.$message.success('保存成功')
        this.closeModel('pointModel')
        this.point = {}
        this.$refs.searchPanel.doSearch()
      })
    },
    editRoom(row) {
      this.activeRow = row
      roomRes.getList({ addressId: row.id }).then(res => {
        this.roomList = res
        this.openModel('roomModel')
      })
    },
    saveRoom(data) {
      roomRes
        .saveRoom({ addressId: this.activeRow.id, examPlacePostList: data })
        .then(res => {
          this.$message.success('保存成功')
          this.closeModel('roomModel')
          this.$refs.searchPanel.doSearch()
        })
    },
    handleDelete(row) {
      this.$confirm('确认删除该考点?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        postRes.deletePost({ id: row.id }).then(res => {
          this.$refs.searchPanel.doSearch()
          this.$message.success('删除成功')
        })
      })
    },
    downLoadTemplate() {
      postRes.exportExamAddressTmpl().then(res => {
        this.downloadFiles(res, '考点模版');
      })
    },
    importPoint() {
      console.log('===')
      this.$refs.importModel.open()
    },
    confirmImportPoint(formData) {
      //导入哪个招考信息
      var { examId } = this.$refs.searchPanel.queryVal
      formData.append('examId', examId)
      postRes.importExamAddress(formData).then(res => {
        this.$message.success('导入成功')
        this.$refs.importModel.close()
        this.$refs.searchPanel.doSearch()
      })
    }
  }
}
</script>
<style lang="scss" >
</style>


